import { CCard, CCardBody, CSmartTable } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilArrowLeft } from '@coreui/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Loader from 'src/components/Loader'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'

const formatDate = (date) => (date ? moment(date).format('D.MM.YYYY') : '—')
const formatTime = (time) => (time ? moment(time, ['HH:mm']).format('h:mm A') : '—')

const tableColumns = [
  { key: 'sn', label: 'SN', filter: false, sorter: false, _style: { width: '8%' } },
  { key: 'player_name', label: 'Player Name', filter: false, sorter: false },
  { key: 'created_at', label: 'Created On', filter: false, sorter: false },
]

const ShowSquaD = () => {
  const [PlayerData, setPlayerData] = useState()
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [loader, setLoader] = useState(false)
  const param = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    setLoader(true)
    ScorecardService.showSquad(param.fixtureId)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false)
          setPlayerData(res.data)
          setFixtureDetails(res.fixture_data)
        }
      })
      .catch((e) => {
        ToastComponent('Something went wrong. Please try again.', 'error')
        setLoader(false)
      })
  }, [param.fixtureId])

  const tableScopedColumns = {
    sn: (item, index) => <td>{index + 1}</td>,
    player_name: (item) => <td className="fw-semibold">{item.player_name}</td>,
    created_at: (item) => <td>{formatDate(item.created_at)}</td>,
  }

  return (
    <>
      <div className="ge-page-header">
        <button
          type="button"
          className="ge-back-link"
          onClick={() => navigate('/completed-fixtures')}
        >
          <CIcon icon={cilArrowLeft} />
          Back to Completed Fixtures
        </button>
        <h1 className="ge-page-title">
          Squad {fixtureDetails.team_name && <>&mdash; {fixtureDetails.team_name}</>}
        </h1>
        <p className="ge-page-subtitle">Players named in the squad for this fixture.</p>
      </div>

      <div className="ge-meta-strip">
        <div className="ge-meta-item">
          <span className="ge-meta-label">Round</span>
          <span className="ge-meta-value">{fixtureDetails.round ?? '—'}</span>
        </div>
        <div className="ge-meta-item">
          <span className="ge-meta-label">Team</span>
          <span className="ge-meta-value">{fixtureDetails.team_name ?? '—'}</span>
        </div>
        <div className="ge-meta-item">
          <span className="ge-meta-label">Starts</span>
          <span className="ge-meta-value">
            {formatDate(fixtureDetails.start_date)}, {formatTime(fixtureDetails.start_time)}
          </span>
        </div>
        <div className="ge-meta-item">
          <span className="ge-meta-label">Ends</span>
          <span className="ge-meta-value">
            {formatDate(fixtureDetails.end_date)}, {formatTime(fixtureDetails.end_time)}
          </span>
        </div>
      </div>

      <CCard>
        <CCardBody>
          <h5 className="mb-3">Squad</h5>
          {loader ? (
            <Loader />
          ) : PlayerData && PlayerData.length > 0 ? (
            <div className="ge-datatable ge-datatable--static">
              <CSmartTable
                columns={tableColumns}
                scopedColumns={tableScopedColumns}
                items={PlayerData}
                tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
              />
            </div>
          ) : (
            <div className="text-medium-emphasis text-center py-4">
              No players named in the squad for this fixture yet.
            </div>
          )}
        </CCardBody>
      </CCard>
    </>
  )
}

export default ShowSquaD
